module.exports = __webpack_public_path__ + "static/media/favicon.45a1ef2b.ico";